import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import api from '../services/api';

export default function AuthImage({ src, alt, style, onClick }) {
  const [blobUrl, setBlobUrl] = useState('');
  useEffect(() => {
    if (!src) return undefined;
    let objectUrl = '';
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(src, { responseType: 'blob', timeout: 60000 });
        const blob = res.data;
        if (blob?.type && String(blob.type).includes('application/json')) return;
        objectUrl = URL.createObjectURL(blob);
        if (!cancelled) setBlobUrl(objectUrl);
      } catch (_) {
        /* leave placeholder */
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);
  if (!blobUrl) {
    return (
      <Box
        onClick={onClick}
        sx={{
          width: style?.width || 120,
          height: style?.height || 120,
          bgcolor: 'action.hover',
          borderRadius: 1,
        }}
      />
    );
  }
  return <img src={blobUrl} alt={alt || ''} style={style} onClick={onClick} />;
}
